import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Sur un feu de véhicule électrique, pouvoir refroidir la batterie par-dessous et sortir l'épave sans risque, c'est un vrai bond en avant pour la sécurité de mes équipes.",
    name: "Cdt. Julien Marchand",
    role: "Chef de centre, sapeurs-pompiers",
  },
  {
    quote:
      "On enlève désormais les véhicules en panne ou mal garés sans grue ni démarrage. Plus rapide, plus propre, et zéro dommage sur les véhicules.",
    name: "Sophie Renard",
    role: "Responsable d'exploitation, fourrière",
  },
  {
    quote:
      "Dans l'atelier comme dans le showroom, on déplace les voitures au centimètre près sans clé. On a gagné en place et en sérénité.",
    name: "Hervé Lacroix",
    role: "Gérant, garage & concession",
  },
];

export default function Testimonials() {
  return (
    <section id="temoignages" data-testid="testimonials-section" className="py-24 lg:py-32 bg-white border-y border-zinc-200">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl">
          <p className="font-mono-tech text-sm uppercase tracking-[0.2em] text-[#E63946] font-semibold">
            Ils utilisent Sapeur-360
          </p>
          <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold tracking-tight">
            La parole aux professionnels du terrain.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex flex-col border border-zinc-200 rounded-sm p-8 bg-[#FAFAFA]"
            >
              <Quote className="h-7 w-7 text-[#E63946]" />
              <blockquote className="mt-5 flex-1 text-[#0A0A0A] leading-relaxed">"{t.quote}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 pt-5 border-t border-zinc-200">
                <span className="grid h-11 w-11 place-items-center rounded-sm bg-[#0A0A0A] text-white font-display font-bold">
                  {t.name.split(" ").slice(-1)[0][0]}
                </span>
                <div>
                  <div className="font-bold text-sm">{t.name}</div>
                  <div className="font-mono-tech text-xs text-[#A1A1AA] uppercase tracking-wider">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
